module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"options":["I\u0027m still here","Start Over"],"headerText":"Are you still there?","sessionEndMsg1":"Your session will timeout in","sessionEndMsg2":"seconds"},"es":{"options":["Todavía Estoy Aquí","Comenzar de Nuevo"],"headerText":"¿Sigues ahí?","sessionEndMsg1":"Su sesión expirará en","sessionEndMsg2":"segundos"}}')
  delete Component.options._Ctor
}
